window.quickviewProperties = {};
const frenzy_get_product_json = async function(url, html,currency_status){
  // jQuery.getJSON(url, function(product) {
  fetch(url)
  .then(response => response.json())
  .then(product => {
    var product_option = product.options;
    var product_variants = product.variants;
    product_option.forEach(function(val,key){
      if(val?.name == 'Color'){
        var index = key;
        var colorlist = [];
        var color = '';
        var tempList = '';
        product_variants.forEach(function(variant_val, variant_key){
           color = variant_val.options[index];
          colorlist.push(color);
        });
        let color_unique = colorlist.filter((item, i, ar) => ar.indexOf(item) === i);
        document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
          color_unique.forEach(function(v,k){
            this_section.querySelector('.product_card_color_title').innerHTML = v;
             var color_class= 'color-no-'+k;
            this_section.querySelector('.product_card_color_title').classList.add(color_class);
          });
          
        });
      }
    })
    if(currency_status != 1){
      document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
        const getVariantID = this_section.querySelector('.frenzy_product_price_meta').getAttribute("data-variantid");
        const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
        const newPrice = getCurrentVariant.price / 100;
        const newComparePrice = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0;
        const price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
        const compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency); 
        this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
        if(getCurrentVariant.compare_at_price != null && (newComparePrice > newPrice)){
          this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
          this_section.querySelector('.frenzy_product_price_compare').setAttribute('aria-label',`Original price: ${compare_price}`);
          // this_section.querySelector('.frenzy_product_price_compare').innerHTML = '';  
        }
      });
    }
  })
}
const bundle_frenzy_get_product_json = async function(url, html,settingData,is_sale){
  // jQuery.getJSON(url, function(product) {
  fetch(url)
  .then(response => response.json())
  .then(product => {
          var getVariantID = html.getAttribute('value');
          const $frenzy_bundle_parent = html.closest(
                    ".frenzy_bundle_innercode"
                  );
          const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
          let bundle_compare_price = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0;
          let bundle_price = getCurrentVariant.price? getCurrentVariant.price : 0;
          if(bundle_compare_price && bundle_compare_price > bundle_price){
            bundle_compare_price = bundle_compare_price
          }
        
            var frenzy_bundle_sale_price =bundle_price;
     if(settingData?.discount_amount > 0){
                    is_discount = true;
                frenzy_bundle_sale_price =
                  settingData?.discount_type == "percentage" ? (bundle_price  * (100 - settingData?.discount_amount)) / 100 :bundle_price  - settingData?.discount_amount * 100;
            }
        
           html.setAttribute('data-price',frenzy_bundle_sale_price);
           html.setAttribute('data-orgprice',bundle_price);
           const salePrice = money_format_Frenzy(frenzy_bundle_sale_price,frenzy_shop_currency);
           const comparePrice = money_format_Frenzy(bundle_compare_price,frenzy_shop_currency);
           if(html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_main_price') != null){
            html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_main_price').setAttribute('aria-label', `Sale price: ${salePrice}`);
           }
           if(html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_compare_price') != null){
            html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_compare_price').setAttribute('aria-label', `Original price: ${comparePrice}`);
           }
          if(bundle_compare_price != 0){
            const NewCompareDiv = '<span class="frenzy_bundle_product_compare_price"><span class="money"></span></span>';
            if(!html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_price .frenzy_bundle_product_compare_price')){
              html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_price').insertAdjacentHTML('beforeend',NewCompareDiv)
            }
            html.setAttribute('data-org_msrp_price',bundle_compare_price);
          }
          if(is_sale && (bundle_compare_price != 0 && bundle_compare_price > bundle_price)){
            if(!html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_price em')){
              html.closest('.frenzy_bundle_product_details_inner').querySelector('.frenzy_bundle_product_price').insertAdjacentHTML('beforeend','<em>*</em>');
            }
          }
          $frenzy_bundle_final_total(
                    $frenzy_bundle_parent,
                    settingData
                  );
  })
}
window.FrenzyAfterBundlePriceChangeCallBack = async function(data,settingData){
  const matchingProducts = data?.data?.matching_products;
  let is_sale = false;
  (matchingProducts || []).map((prod) => {
    if(prod?.org_template_suffix == "product-clearance"){
      is_sale = true
    }
  })
  const variant_option_type = settingData?.select_option == "all_options" ? "all_options" : "size";
  document.querySelectorAll('.frenzy_pb_details .frenzy_bundle_product_grid').forEach(function(this_click){
    var product_handle = this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val').getAttribute('data-handle');
     var html =  this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val');

    bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle+'.js', html,settingData,is_sale).then(frenzy_product_response => {return frenzy_product_response});
  });
}
function cartCountUpdate() {
  console.log("cartCountUpdate()")
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const resItems = cart.items;
    let cartItemCount = resItems.length;
    const itemFound = resItems.find(product => product.product_id === 7265701757015);
    if(itemFound){
      cartItemCount = Number(resItems.length - 1);
    }
    setTimeout(() => {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((this_item) => {
            this_item.innerHTML = cartItemCount;
        });
    }, 1000);
  });
}
window.frenzyCartCallBack = async (res) => {

  var cartItems = document.querySelector('cart-drawer');
   const $this_cart_type = document.querySelector('cart-drawer');
   const $get_section_content_url = '/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text,cart_footer';
  let $cart_item_first_val = res;
    fetch($get_section_content_url, {
    method: "GET"
  }).then((response) => response.json()).then((data) => {
    $cart_item_first_val['sections'] = data;
    const quickAddModal = document.querySelector('quick-add-modal');
    if(document.querySelector('.frenzy_loading_spinner')){
        document.querySelector('.frenzy_loading_spinner').remove();  
    }
      // $this_cart_type.renderContents($cart_item_first_val);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      cartItems.setAttribute("open", "")
      // frenzyGridLoad();
  });
  if($this_cart_type.classList.contains('close-drawer') == true){
      // $this_cart_type.viewDrawer();
  }
  // cartCountUpdate();
  // setCartSwiper();
}
const productGridSwatch = async (handle,sku,html,sv_fabric,colorName) => {
  const var_id = sku.split('_')[1];
  const frenzy_color_swatch = handle + "?view=frenzy-color-swatch&variant"+var_id;
  // if(configId == 'd2d86418-0482-4a3c-a6ab-dcf21cdea9ab'){
  //   frenzy_color_swatch = handle + "?view=frenzy-colors-dropdown&variant"+var_id;
  // }
   const response = await fetch(frenzy_color_swatch, {
      method: "GET",
  });
  const result = await response.text();
  if(result){
    const new_HTML = new DOMParser().parseFromString(result, "text/html");
    document.querySelectorAll('.frenzy_product_item[data-id="'+sku+'"]').forEach(function(this_click){
      this_click.querySelector('.frenzy_swatch').innerHTML = new_HTML.querySelector('.frenzy-color-swatch').innerHTML;
      // console.log('=======',this_click.querySelector('.frenzy_swatch').innerHTML);
      const getVarIdJson = JSON.parse(this_click.querySelector('.frenzy_swatch .custom-collection-swatches').getAttribute('data-var_json'));
      const getVariantID = this_click.querySelector('.frenzy_product_price_meta').getAttribute("data-variantid");  
      const getCurrentVariant = (getVarIdJson || []).find((y) => y.id == getVariantID);
      const varPrice = getCurrentVariant?.price / 100;
      const varComparePrice = getCurrentVariant?.compare_at_price ? getCurrentVariant?.compare_at_price / 100 : 0;
      this_click.querySelector('.frenzy_product_price_sale .money').innerHTML = money_format_Frenzy((getCurrentVariant?.price / 100) * 100, frenzy_shop_currency);
      this_click.querySelector('.frenzy_product_price_sale').setAttribute('aria-label',`Sale price: ${money_format_Frenzy((getCurrentVariant?.price / 100) * 100, frenzy_shop_currency)}`);
      if(varComparePrice != null && (varComparePrice > varPrice)){
        this_click.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
        this_click.querySelector('.frenzy_product_price_compare .money').innerHTML = money_format_Frenzy((getCurrentVariant?.compare_at_price / 100) * 100, frenzy_shop_currency);
        this_click.querySelector('.frenzy_product_price_compare').setAttribute('aria-label', `Original price: ${money_format_Frenzy((getCurrentVariant?.compare_at_price / 100) * 100, frenzy_shop_currency)}`);
      }
      if(this_click.querySelector('.frenzy_product_fabric') && sv_fabric){
        if(sv_fabric.length < 1){
          this_click.querySelector('.frenzy_product_fabric').innerHTML = sv_fabric;
        }else{
          this_click.querySelector('.frenzy_product_fabric').innerHTML = sv_fabric.join(", ");
        }
      }
      if(colorName === undefined){
        const getsoldoutColor = this_click.querySelector('.collection-swatch.current_item .frenzy-swatch_item').getAttribute('data-color');
        this_click.querySelector('.product_card_color_title').innerHTML = getsoldoutColor;
      }
    })
  }
}

window.frenzyProductGridWidgetCallBack = function () {
  const getHHTML = document.querySelector('#frenzy_product_grid_widget')?.innerHTML || '';
  return getHHTML;
}


const frenzy_get_json = async function(p_id,v_id){
   const frenzy_url = 'https://bombshell.search.frenzy.me/get-product-data?product_id='+p_id;
   const response = await fetch(frenzy_url, {
      method: "GET",
      headers: {
          "Content-Type": "application/json",
          "x-frenzy-authorization": '00bd3bbb-e7af-446d-94a0-0e0024c5bd5a',
          "X-Shop": Shopify?.shop
      },
  });
  const result = await response.json();
  console.log("result", result)
}
window.FrenzyProductGridChangeCallBack = function(html,data){
  // Badges
  let smf_tag_icon = data.smf_tag_icon;
  let smf_tag_title = data.smf_tag_title;
  const smf_badges = data?.smf_badges?.[0] || '';
  const smf_hex_colors = data?.smf_hex_colors?.[0] || '';
  let smf_sale = data?.smf_sale || smf_badges;
  // let smf_sale = smf_badges;
  let smf_second_tag = data.smf_second_tag;
  let sold_out = !data.org_stock_available;
  let frenzy_tag_badge = '';
  let frenzy_second_badge = '';
  let frenzy_sale_badge = '';
  let frenzy_soldout_badge = ''; 
  const $org_msrp_price = data?.org_msrp_price;
  const $org_price = data?.org_price;
  let badgeStyle = '';

  const productTemplate = data?.org_template_suffix;

  setTimeout(function(){
    if(productTemplate == "product-clearance" && ($org_msrp_price && $org_msrp_price > $org_price)){
      document.querySelectorAll('.frenzy_product_item[data-id="'+data?.sku+'"]').forEach(function(this_grid) {
        if(!this_grid.querySelector('.frenzy_product_price_meta').querySelector('em')){
          this_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_compare').insertAdjacentHTML('beforeend','<em>*</em>');
        }
      });
    }
  },500);

  // if (!$org_msrp_price || !$org_price || $org_msrp_price <= $org_price) return;

  // const percentage = Math.round((($org_msrp_price - $org_price) / $org_msrp_price) * 100);
  // const savings = `${percentage}%`;
    
  const orgStockAvailable = data?.org_stock_available;
  const frenzySizeOptions = (data?.options || []).find((x) => x.name == 'size');
  const pID = data?.product_id;
  let frenzySizeHTML = '';
  if(!orgStockAvailable){
    (frenzySizeOptions?.data || []).map((size,i) => {
      if(!size.available){
        frenzySizeHTML += `<button disabled="" data-sku="${pID}_${size.id}">${size.label}</button>`;
      }
    });
    setTimeout(function(){
      document.querySelectorAll('.frenzy_product_item[data-id="'+data?.sku+'"]').forEach(function(this_click){
        this_click.querySelector('figure').insertAdjacentHTML('beforeend','<div class="frenzy_variant_option frenzy_vp_size frenzy_switch_type"><div class="frenzy_product_option">'+frenzySizeHTML+'</div></div>');
      });
    },500);
  }

  // if (smf_tag_title) {
  //   if (smf_tag_icon) {
  //     frenzy_tag_badge = `<div class="frenzy_product_tag_badge_inner"><svg data-v-6a658708="" style="width: 15px;" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="badge__icon badge__icon--bolt"><path d="M6.857 19.313c-.461.68.423 1.461 1.04.92l10.266-9.003a.7.7 0 00-.449-1.226l-4.37-.08 2.545-4.895c.365-.702-.533-1.376-1.105-.83l-8.566 8.18a.7.7 0 00.483 1.207h4.046l-3.89 5.727z"></path></svg><span>${smf_tag_title[0]}</span></div>`;
  //   } 
  //   else {
  //     frenzy_tag_badge = `<div class="frenzy_product_tag_badge_inner sale-tag"><span>${smf_tag_title[0]}</span></div>`;
  //   }  
  // } 
  if (smf_second_tag) {
    frenzy_second_badge = `<div class="frenzy_product_sale_badge_inner second-badge-inner"><span>${smf_second_tag[0]}</span></div>`;
  }
  if (sold_out) {
    frenzy_soldout_badge = '<div class="frenzy_product_soldout_badge_inner"><span>SOLD OUT</span></div>';
  }
  // if(smf_badges && smf_hex_colors){
  //   badgeStyle = 'style="background: ' + smf_hex_colors + ';"';
  // }
  var s_html = '<div class="frenzy_product_tag_badge">'+frenzy_tag_badge+'</div><div class="frenzy_product_second_badge">'+frenzy_second_badge+'</div><div class="frenzy_product_sale_badge"><div class="frenzy_product_sale_badge_inner" '+badgeStyle+'>'+smf_sale+'</div></div><div class="frenzy_product_soldout_badge">'+frenzy_soldout_badge+'</div>';
  html.querySelector('.frenzy_product_tags').innerHTML = s_html;
  // frenzy_wishlist_icon
   const varint_id = data.product_id_variant.split("_");
    html.querySelector('.frenzy_product_item').classList.add("FrenzyProductId_"+data.product_id);
    html.querySelector('.frenzy_product_price_meta').setAttribute("data-variantid",varint_id[1]);

  var product_id_variants = data.product_id_variant.split('_');
  var product_id = data.product_id;
  var product_id_variant = product_id_variants[1];
  const product_handle = data.org_prod_url.split("?");
  const product_url = window.location.origin + '/products/'+product_handle[0];
  const p_title = data?.org_product;
  var s_color =  data?.s_color;
  /* Swym wishlist integration removed
  // Swym wishlist button generation removed
      setTimeout(function(){
      if(document.querySelectorAll('.frenzy_product_item[data-id="'+data.sku+'"]').length > 0){
        document.querySelectorAll('.frenzy_product_item[data-id="'+data.sku+'"]').forEach(function(this_click){
          if(this_click.querySelector('.frenzy_wishlist_icon').getAttribute('data-status') == "0"){
             this_click.querySelector('.frenzy_wishlist_icon').innerHTML = wishlist_btn;
             this_click.querySelector('.frenzy_wishlist_icon').setAttribute('data-status',"1"); 
            }
        })
      }
      handleSwymButtonInitialization();
    },800);
  */
 
  if(s_color != undefined){
    let color_unique = s_color.filter((item, i, ar) => ar.indexOf(item) === i);
   color_unique.forEach(function(v,k){html.querySelector('.product_card_color_title').innerHTML = v;});
  }
  // frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html,0).then(frenzy_product_response => {return frenzy_product_response});
  // else{
  //   var currency_status = 0;
  //    if(Shopify.currency.active == frenzy_scripts.currency){
  //      currency_status = 1;
  //    }else{
  //      currency_status = 0;
  //      frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html,currency_status).then(frenzy_product_response => {return frenzy_product_response}); 
  //    }
  // }
  // if(Shopify.currency.active != frenzy_scripts.currency){
   //  frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html,0).then(frenzy_product_response => {return frenzy_product_response});
    // frenzy_get_json(product_id,product_id_variant);
  // }

  productGridSwatch(product_url, data?.sku, html, data?.sv_fabric, data?.s_color);
  // if(__st && (__st.p == 'searchresults' || __st.p == 'collection')){
  //   mobileProductSlider (data);
  // }

  const RivoWishlistHtml = `
    <rivo-favorite-button
      data-product-id="${product_id}"
      rivo-ax-data
      rivo-ax-cloak
      rivo-ax-html="$store.icons.heart"
      rivo-ax-show="$store.rivo_aw_settings?.favorites_enabled && (!$store.rivo_profile_customer || $store.loading_states.global_favorite_buttons)"
    ></rivo-favorite-button>`;

  setTimeout(function(){
    const items = document.querySelectorAll('.frenzy_product_item[data-id="'+data.sku+'"]');
    if(items.length > 0){
      items.forEach(function(this_click){
        this_click.querySelector('.favorite-button-wrapper').innerHTML = RivoWishlistHtml;

        // Re-initialize Rivo for newly inserted favorite button(s)
        if (window.RivoProfileAlpine) {
          const rivoAccountWidget = document.getElementById('rivo-account-slideout');
          try {
            window.RivoProfileAlpine.$data(rivoAccountWidget)?.initializeFavoriteButtons();
          } catch (e) {
            console.warn('Rivo re-init failed:', e);
          }
        }
      });
    } 
  }, 800);


}
function mobileProductSlider(data) {
  setTimeout(function () {
    document.querySelectorAll('.frenzy_product_item[data-id="' + data?.sku + '"]').forEach(function (this_click) {
      if (window.innerWidth < 767) {
        if (data?.org_request_type == "collection" || data?.org_request_type == "search") {
          const frenzyProductImages = data?.org_image_url.split(' ');
          let frenzyProductURL = data?.org_prod_url;
          if (frenzyProductURL.includes('?')) {
            frenzyProductURL = frenzyProductURL.split('?')[0];
          }
          if (frenzyProductImages.length > 1) {
            this_click.classList.add('frenzy_product_item_slider');
            // Add only first 2 images initially
            let frenzyImgAdd = '';
            frenzyProductImages.slice(0, 2).forEach((prodImg, index) => {
              const imgClass = index === 0 ? 'frenzy_img_first' : 'frenzy_img_second';
              const resizedImg = prodImg.replace(/(\.(jpg|jpeg|png|webp))(.*)?$/, '_1000x$1');
              frenzyImgAdd += `<div class="swiper-slide"><img class="frenzy_img ${imgClass}" src="${resizedImg}" alt="" /></div>`;
            });
            const figureLink = this_click.querySelector('figure a');
            figureLink.innerHTML = `<div class="frenzy-mobile-image-grid swiper-wrapper">${frenzyImgAdd}</div><div class="grid-swiper-scrollbar"></div>`;
            const wrapper = figureLink.querySelector('.swiper-wrapper');
            wrapper.setAttribute('data-all-images', JSON.stringify(frenzyProductImages));
            wrapper.setAttribute('data-loaded-count', '2');
            if (!this_click.querySelector('.grid-swiper-button-prev') && !this_click.querySelector('.grid-swiper-button-next')) {
              const buttonsHTML = `<button class="grid-swiper-button-prev swiper-button-prev1"></button><button class="grid-swiper-button-next swiper-button-next1"></button>`;
              this_click.querySelector('figure').insertAdjacentHTML('beforeend', buttonsHTML);
            }
            const swiperContainer = figureLink;
            mobielSwiperCall(swiperContainer, this_click, frenzyProductImages);
          }
        }
      }
    });
  }, 500);
}
window.mobielSwiperCall = function (swiperContainer, this_click, allImages) {
  setTimeout(() => {
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
      swiperContainer.swiper = null;
    }
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    let loadedImagesCount = parseInt(wrapper.getAttribute('data-loaded-count')) || 2;

    if (!swiperContainer.swiper) {
      swiperContainer.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        freeMode: false,
        nested: true,
        a11y: false,
        keyboard: { enabled: true },
        passiveListeners: false,
        navigation: {
          nextEl: this_click.querySelector('.grid-swiper-button-next'),
          prevEl: this_click.querySelector('.grid-swiper-button-prev'),
        },
        scrollbar: {
          el: '.grid-swiper-scrollbar',
          draggable: true,
          dragSize: 50,
          hide: true,
        },
        on: {
          slideChange: function () {
            const currentIndex = this.activeIndex;
            const scrollbarEl = this.scrollbar?.el;
   
            while (loadedImagesCount <= currentIndex + 1 && loadedImagesCount < allImages.length) {
              const newSlide = document.createElement('div');
              const originalImageUrl = allImages[loadedImagesCount];
              const resizedImageUrl = originalImageUrl.replace(/(\.(jpg|jpeg|png|webp))(.*)?$/, '_1000x$1');
              newSlide.className = 'swiper-slide';
              newSlide.innerHTML = `<img class="frenzy_img" src="${resizedImageUrl}" alt="" />`;
              wrapper.appendChild(newSlide);
              loadedImagesCount++;
              wrapper.setAttribute('data-loaded-count', loadedImagesCount.toString());
            }
            swiperContainer.swiper.update();
            if (scrollbarEl) {
              scrollbarEl.classList.add('scrollbar-visible');
            }
            if (scrollbarEl) {
              scrollbarEl.classList.add('scrollbar-visible');
            }
          },
          touchStart: function () {
            const scrollbarEl = this.scrollbar?.el;
            if (scrollbarEl) {
              scrollbarEl.classList.add('scrollbar-visible');
            }
            setTimeout(() => {
              scrollbarEl?.classList.remove('scrollbar-visible');
            }, 4000);
         }
        },
      });
    }
  }, 300);
};
window.frenzySwiperSliderCallBack = function(className, frenzy_infinite_loop){
     var swiper = new Swiper(
          className + " .frenzy_recommendation_contain",
          {
            slidesPerView: "auto",
            freeMode: true,
            spaceBetween: 0,
            watchOverflow: true,
            centerInsufficientSlides: false,
            loop: frenzy_infinite_loop,
            observer: true,
            observeParents: true,
            a11y: true,

            mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 1,
            },

            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },

            scrollbar: {
              hide: false,
              el: className + " .swiper-scrollbar",
              draggable: true,
            },

            navigation: {
              nextEl: className + " .swiper-button-next",
              prevEl: className + " .swiper-button-prev",
            },

            pagination: {
              el: className + " .swiper-pagination",
              type: "progressbar",
            },
	          }
	        );
      return swiper;
	    //  enableSwiperLiveAnnouncement(swiper);
	}

function frenzySwatchClickEvent(this_click) {
  const this_closest = this_click?.closest('.custom-collection-swatches').querySelectorAll('.collection-swatch');
  const this_parentEle = this_click?.parentElement;
  const product_grid = this_click && this_click?.closest('.frenzy_product_item');
  const check_cartPopup = product_grid.closest('.frenzy_cart_popup_section');
  const pID = this_click?.getAttribute('data-prod-id');    
  const vID = this_click?.getAttribute('data-variant-id');  
  const featured_img = this_click?.getAttribute('data-featured-image');
  const second_img = this_click?.getAttribute('data-second-image');
  const getAllImages = JSON.parse(this_click?.getAttribute('data-images'));
  const allImages = getAllImages?.[0] || [];
  if (allImages.length === 0) return;
  const product_price = this_click?.getAttribute('data-price');
  const product_compare_price = this_click?.getAttribute('data-compare-price');
  const frenzy_color_swatch = JSON.parse(this_click?.getAttribute('data-variant')); 
  const sizeIndex = this_click?.getAttribute('data-size-index');
  const prodHandle = this_click?.getAttribute('data-handle');
  const prodUrl = window.location.origin + prodHandle;
  const prodTitle = this_click?.getAttribute('data-title');
  const getfrenzAttr =  product_grid.querySelector('figure a');  
  const swiperContainer = product_grid.querySelector('.frenzy_product_item_slider figure a');
  const updatePopup = product_grid.querySelector('.quick-view-custom-button');
  const sv_fabric = this_click?.getAttribute('data-fabric');   
  const sv_color = this_click?.getAttribute('data-color'); 
  const tag_title = this_click?.getAttribute('data-tag-title');
  const tag_icon = this_click?.getAttribute('data-tag-icon');
  const second_tag = this_click?.getAttribute('data-second-tag');
  const sale_tag = this_click?.getAttribute('data-sale');
  const smfBadegs = this_click?.getAttribute('data-badges');
  const smfBadegClr = this_click?.getAttribute('data-badge_color');
  const soldout_tag = this_click?.getAttribute('data-soldout');
  let frenzy_product_badge = '';
  let frenzy_prod_second_badge = '';
  let frenzy_prod_sale_badge = '';
  let frenzy_prod_soldout_badge = ''; 
  product_grid.querySelector('.frenzy_product_title a').innerHTML = prodTitle;
  getfrenzAttr?.setAttribute('href',prodHandle);
  updatePopup?.setAttribute('data-product-id',prodHandle);
  const config_id = getfrenzAttr?.getAttribute('data-config_id');
  const data_name = getfrenzAttr?.getAttribute('data-name');
  const request_id = getfrenzAttr?.getAttribute('data-request_id');
  getfrenzAttr.setAttribute('data-sku', pID + '_' + vID);
  let productVarHTML = '';
  let cartdrawerVarHTML = '';
  if(window.innerWidth > 768){
    if(featured_img){
      const new_featured_img = featured_img.replace('_100x.','_1000x.');
      product_grid.querySelector('figure .frenzy_img_first').setAttribute('src',new_featured_img);
    };
    if(second_img){
      const new_second_img = second_img.replace('_100x.','_1000x.');
      product_grid.querySelector('figure .frenzy_img_second').setAttribute('src',new_second_img);
    };
  }else {
      if(swiperContainer){
      const wrapper = swiperContainer.querySelector('.frenzy-mobile-image-grid');
        wrapper.innerHTML = '';
        allImages.slice(0, 2).forEach((img, i) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          const imgClass = i === 0 ? 'frenzy_img frenzy_img_first' : 'frenzy_img frenzy_img_second';
          slide.innerHTML = `<img class="${imgClass}" src="${img}" alt="" />`;
          wrapper.appendChild(slide);
        });
        wrapper.setAttribute('data-all-images', JSON.stringify(allImages));
        wrapper.setAttribute('data-loaded-count', '2');
        wrapper.setAttribute('data-all-images-appended', 'false');
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
          swiperContainer.swiper = null;
        }
        setTimeout(() => {
          mobielSwiperCall(swiperContainer,product_grid,allImages);
        }, 300);
    }
    else{
      if(featured_img){
        const new_featured_img = featured_img.replace('_100x.','_1000x.');
        product_grid.querySelector('figure .frenzy_img_first').setAttribute('src',new_featured_img);
      };
      if(second_img){
        const new_second_img = second_img.replace('_100x.','_1000x.');
        product_grid.querySelector('figure .frenzy_img_second').setAttribute('src',new_second_img);
      };
    }
  }
  if(product_price){
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_sale .money').innerHTML = product_price;
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_sale').setAttribute('aria-label',`Sale price: ${product_price}`);
  }
  if(product_compare_price){
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_sale').classList.add('is-sale');
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_compare .money').innerHTML = product_compare_price;
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_compare').setAttribute('aria-label',`Original price: ${product_compare_price}`);
  }else{
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_compare .money').innerHTML = '';
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_sale').classList.remove('is-sale');
    product_grid.querySelector('.frenzy_product_price_meta .frenzy_product_price_compare').setAttribute('aria-label','');
  }
  if(sv_color){product_grid.querySelector('.product_card_color_title').innerHTML = sv_color}

  this_closest.forEach(item => {
    item.classList.remove('clicked','current_item');
  })
  this_parentEle.classList.add('clicked','current_item');
  (frenzy_color_swatch || []).map((x,i) => {
    const label = sizeIndex == 1 ? x.option1 : sizeIndex == 2 ? x.option2 : x.option3;
    const x_price = money_format_Frenzy(x.price, frenzy_shop_currency);
    if(x.available){
     productVarHTML += `<button type="button" onclick="frenzyQuickAddEvent(this)" data-image="${x.featured_image}" data-price="${x_price}" data-config_id="${config_id}" data-name="${data_name}" data-sku="${pID}_${x.id}" data-request_id="${request_id}">${label}</button>`
     cartdrawerVarHTML += `<option data-image="${x.featured_image}" data-price="${x_price}" data-name="add_cart" value="${pID}_${x.id}" data-request_id="${request_id}">${label}</option>`;
    }else{
      productVarHTML += `<button disabled="" data-sku="${pID}_${x.id}">${label}</button>`
    }
  });

  if(check_cartPopup){
    product_grid.querySelector('.frenzy_product_item_detail .frenzy_pro_select_option').innerHTML = cartdrawerVarHTML;
    if(product_grid.querySelectorAll('.frenzy_product_item_detail .frenzy_pro_select_option')){
      const firstSelected_var = product_grid.querySelectorAll('.frenzy_product_item_detail .frenzy_pro_select_option option')[0]?.value;
      product_grid.querySelector('.frenzy_product_item_detail .frenzy_auickAdd_cart').setAttribute('data-sku',firstSelected_var);
    }
  }
  if(productVarHTML){
    if (product_grid.querySelector('.frenzy_product_option')) {
      product_grid.querySelector('.frenzy_product_option').innerHTML = productVarHTML;
    } else {
      product_grid.querySelector('figure').insertAdjacentHTML('beforeend','<div class="frenzy_variant_option frenzy_vp_size frenzy_switch_type"><div class="frenzy_product_option">'+productVarHTML+'</div></div>');
    }
  } 
  
  if (tag_title) {
    if (tag_icon) {
      frenzy_product_badge = `<div class="frenzy_product_tag_badge_inner"><svg data-v-6a658708="" style="width: 15px;" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="badge__icon badge__icon--bolt"><path d="M6.857 19.313c-.461.68.423 1.461 1.04.92l10.266-9.003a.7.7 0 00-.449-1.226l-4.37-.08 2.545-4.895c.365-.702-.533-1.376-1.105-.83l-8.566 8.18a.7.7 0 00.483 1.207h4.046l-3.89 5.727z"></path></svg><span>${tag_title}</span></div>`;
    } 
    else {
      frenzy_product_badge = `<div class="frenzy_product_tag_badge_inner sale-tag"><span>${tag_title}</span></div>`;
    }  
  } 
  if (second_tag) {
    frenzy_prod_second_badge = `<div class="frenzy_product_sale_badge_inner second-badge-inner"><span>${second_tag}</span></div>`;
  }
  if (smfBadegs || sale_tag) {
    if(smfBadegs && smfBadegClr){
      const badgeStyle = `style= background: ${smfBadegClr};`;
      frenzy_prod_sale_badge = `<div class="frenzy_product_sale_badge_inner" ${badgeStyle}><span>${smfBadegs}</span></div>`;
    }else{
      frenzy_prod_sale_badge = `<div class="frenzy_product_sale_badge_inner"><span>${sale_tag}</span></div>`;
    }
  }
  if (soldout_tag !== 'true') { 
    frenzy_prod_soldout_badge = '<div class="frenzy_product_soldout_badge_inner"><span>SOLD OUT</span></div>';
  }else{ 
    if(product_grid.querySelector('figure .frenzy_product_soldout_badge') != null){
      product_grid.querySelector('figure .frenzy_product_soldout_badge').innerHTML = '';
    }
  }
  var tag_html = '<div class="frenzy_product_tag_badge">'+frenzy_product_badge+'</div><div class="frenzy_product_second_badge">'+frenzy_prod_second_badge+'</div><div class="frenzy_product_sale_badge">'+frenzy_prod_sale_badge+'</div><div class="frenzy_product_soldout_badge">'+frenzy_prod_soldout_badge+'</div>';
  product_grid.querySelector('.frenzy_product_tags').innerHTML = tag_html;
  var wishlist_btn = '<button data-with-epi="true" class="tw-z-10 app_btn_wsh wishlist-btn swym-loaded swym-button-collection swym-button swym-add-to-wishlist-view-product product_'+pID+'" data-swaction="addToWishlist" data-product-id="'+pID+'" data-variant-id="'+vID+'" data-product-url="'+prodUrl+'" aria-label="Add to Wishlist '+prodTitle+'"><p class="hidden" data-product-status role="status">'+prodTitle+'</p></button>';
  // Swym wishlist rendering removed
  
  // Swym wishlist initialization removed
}
window.frenzAfterApiCallBack = function(all_product_data){
  // Swym wishlist initialization removed
  // if(__st && (__st.p == 'searchresults' || __st.p == 'collection')){
  //   mobileProductSlider (all_product_data);
  // }
  // setTimeout(()=>{setCartSwiper();},500)
  if(__st && __st.p == 'searchresults'){
      const getSearchQuery = all_product_data?.results?.corrected_query;
      const productsFound = all_product_data?.results?.products_found;
      setTimeout(() => {
          if(productsFound && getSearchQuery){
              if (document.querySelector('.shopify-section--main-search .search-banner .frenzy-search-text')) {
                  document.querySelector('.shopify-section--main-search .search-banner .frenzy-search-text').innerHTML = `${productsFound} results for "${getSearchQuery}"`;
              }
          }
      }, 500);
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  // Swym wishlist initialization removed
  // document.querySelector('.header__main-nav .header__icon-list > a').addEventListener('click',function(e) {
  //   e.preventDefault();
  //   e.stopImmediatePropagation();
  // })

});

/* Swym wishlist initialization removed
window.handleSwymButtonInitialization = function() {
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function(swat) {
    swat.initializeActionButtons('body');
  });
}
*/
// window.frenzyAnimationCallBack = () => {
//     let frenzyUpdatePlaceholder = '';
//     const gridLength = 32;
//     frenzyUpdatePlaceholder += '<div class="frenzy_collection_page_loader_content">';
//     frenzyUpdatePlaceholder += '<div class="frenzy_container">';
//     frenzyUpdatePlaceholder += '<div class="frenzy_topbar_loader_content">';
//     frenzyUpdatePlaceholder += '<div class="frenzy_filter_loader_content "></div>';
//     frenzyUpdatePlaceholder += '<div class="frenzy_sorting_loader_content"></div>';
//     frenzyUpdatePlaceholder += '<div class="frenzy_sorting_loader_content"></div>';
//     frenzyUpdatePlaceholder += '<div class="frenzy_empty_loader_content"></div>';
//     frenzyUpdatePlaceholder += '<div class="frenzy_orientation_loader_content">';
//     frenzyUpdatePlaceholder += '<span></span>';
//     frenzyUpdatePlaceholder += '<span></span>';
//     frenzyUpdatePlaceholder += '<span></span>';
//     frenzyUpdatePlaceholder += '<span></span>';
//     frenzyUpdatePlaceholder += '</div>';
//     frenzyUpdatePlaceholder += '</div>';
//     frenzyUpdatePlaceholder += '<div class="frenzy_content_loader_row">';
//     frenzyUpdatePlaceholder += '<div class="frenzy_loader_row loader_grid_4">';
//     for(var i = 1; i <= gridLength; i++ ){
//       frenzyUpdatePlaceholder += '<div class="frenzy_loader_grid">';
//       frenzyUpdatePlaceholder += '<figure>';
//       frenzyUpdatePlaceholder += '<img src="https://cdn.frenzyai.click/plugin/placeholder.png" />';
//       frenzyUpdatePlaceholder += '</figure>';
//       frenzyUpdatePlaceholder += '<p></p>';
//       frenzyUpdatePlaceholder += '<span></span>';
//       frenzyUpdatePlaceholder += '</div>';
//     }
//     frenzyUpdatePlaceholder += '</div>';
//     frenzyUpdatePlaceholder += '</div>';
//    frenzyUpdatePlaceholder += '</div>';
//    frenzyUpdatePlaceholder += '</div>';
//     return frenzyUpdatePlaceholder;
// }
/*
window.fourSixtyView = function() {
  const intervalId = setInterval(() => {
    const fourSixtyEle = document.querySelectorAll('.fs-entry-container');
    const fourSixtyWrapper = document.querySelector('.fs-wrapper.fs-timeline');
  
    if (fourSixtyEle.length && fourSixtyWrapper) {
      fourSixtyWrapper.setAttribute('data-grid', fourSixtyEle.length);
      clearInterval(intervalId);
    }
  }, 300);
}
// Free product JS start
*/
// Free product JS start
function addFreeProduct(responseData){
  if(responseData != null){
    const freeShipEl = document.querySelector('.free-product_message');
    const productPrice = freeShipEl?.getAttribute('data-product_price') / 100;
    let totalAmount = responseData?.total_price / 100;
    const cartTotal = money_format_Frenzy(totalAmount * 100, frenzy_shop_currency); 
    // const getAmount = parseFloat(freeShipEl?.getAttribute('data-amount'));
    const getAmount = parseFloat(freeShipEl?.getAttribute('data-amount')) / Shopify.currency.rate;
    const message = freeShipEl?.getAttribute('data-message') || '';
    const productTitle = freeShipEl?.getAttribute('data-product_title') || '';
    const finalAmount = money_format_Frenzy(getAmount * 100, frenzy_shop_currency);
    const finalMessage = message.replace('[[amount]]', money_format_Frenzy(getAmount * 100, frenzy_shop_currency)).replace('[[product_title]]', productTitle);
    const getVarId = freeShipEl?.getAttribute('data-variant_id');
    if(freeShipEl){
      freeShipEl.querySelector('span').innerHTML = finalMessage;
      const isProductAvailable = (responseData?.items || []).find((x) => x.id == getVarId);
      let formData = {
       'items': [{
        'id': getVarId,
        'quantity': 1,
        }],
      };
      if(isProductAvailable){
        totalAmount = responseData?.total_price > 0 ? (responseData?.total_price / 100) - productPrice : 0;
      }
      if(totalAmount > getAmount && !isProductAvailable ) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          if (typeof frenzyCartCallBack === "function") {
            frenzyCartCallBack(data);
          }
        })
        .catch((error) => console.error('Add error:', error));
      }else if(totalAmount < getAmount && isProductAvailable) {
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: getVarId,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(data => {
          if (typeof frenzyCartCallBack === "function") {
            frenzyCartCallBack(data);
          }
        })
        .catch((error) => console.error('Remove error:', error));
      }
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  window.fetch = new Proxy(window.fetch, {
    apply(cartItems_fetch, cartItems_that, cartItems_args) {
      const cartItems_result = cartItems_fetch.apply(cartItems_that, cartItems_args);
      return cartItems_result.then(async (response) => {
        const clonedResponse = response.clone();
        const contentType = clonedResponse.headers.get("content-type") || '';
        let responseData = null;
        try {
          if (contentType.includes("application/json")) {
            responseData = await clonedResponse.json();
          } else {
            const textData = await clonedResponse.text();
            // console.warn("Response is not JSON:", textData);
          }
        } catch (error) {
          const textData = await clonedResponse.text();
          // console.error("Failed to parse JSON response:", error, '\nRaw response:', textData);
        }
        let fetchUrl = '';
        if (typeof cartItems_args[0] === 'string') {
          fetchUrl = cartItems_args[0];
        } else if (cartItems_args[0] instanceof Request) {
          fetchUrl = cartItems_args[0].url;
        }
        const shouldTriggerCartUpdate =
          fetchUrl.search(/cart.*js|cart\/change|cart\/add/) >= 0 &&
          !fetchUrl.includes('/cart.js?currency=');
          !fetchUrl.includes('/cart.js?bundle') &&
          !fetchUrl.includes('/cart.js?src=ss') &&
          !fetchUrl.includes('/cart.json?icu=1');
        if (shouldTriggerCartUpdate) {
          setTimeout(() => {
           addFreeProduct(responseData);
          }, 500);
        }
        return response;
      });
    },
  });
  // fourSixtyView();
    const interval = setInterval(() => {
    const ratingZero = document.querySelector('.stamped-product-reviews-badge .stamped-badge[data-rating="0.0"]');
    if (ratingZero) {
      const badge = ratingZero.closest('.stamped-product-reviews-badge');
      if (badge) {
        badge.style.display = 'none';
      }
      clearInterval(interval);
    }
  }, 200);
  // cartCountUpdate();
  updateQuickScript();
});
// Free product JS end


// ADA Create a live region once
function enableSwiperLiveAnnouncement(swiperInstance) {
  let liveRegion = document.getElementById('swiper-live-status');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'swiper-live-status';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.classList.add('sr-only');
    document.body.appendChild(liveRegion);
  }

  // On every slide change, update announcement text
  swiperInstance.on('slideChange', function () {
    const current = this.activeIndex + 1;
    const total = this.slides.length;
    liveRegion.textContent = `Slide ${current} of ${total} active`;
  });
}


// slider only visilbe slide read ada
function getVisibleSlides(swiper, minVisibleRatio = 0.5) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const containerRect = swiper.el.getBoundingClientRect();
      const visible = Array.from(swiper.slides).filter((slide) => {
        const rect = slide.getBoundingClientRect();
        const overlap =
          Math.max(0, Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left));
        const visibleRatio = overlap / rect.width;
        return visibleRatio > minVisibleRatio;
      });
      resolve(visible);
    }, 500);
  });
}

async function logVisible(swiper) {
  const slides = Array.from(swiper.slides);
  slides?.forEach((slide) => {slide.classList.remove('visible_slide');slide.classList.remove('frenzy_visibility_hidden');});
  const visible = await getVisibleSlides(swiper);
  visible?.forEach((slide) => slide.classList.add('visible_slide'));
  slides?.forEach((slide) => {
    if(slide.classList.contains('visible_slide')){
      slide.setAttribute('tabindex', '0');slide.setAttribute('aria-hidden', 'false');
      slide.classList.remove('frenzy_visibility_hidden');
    }else{
      slide.setAttribute('tabindex', '-1');slide.setAttribute('aria-hidden', 'true');
      slide.classList.add('frenzy_visibility_hidden');
    }
  });
}

function setCartSwiper(){
  setTimeout(()=>{
    if(document.querySelector('.frenzy_cart_popup_section .frenzy_recommendation_contain')){
      const container = document.querySelector('.frenzy_cart_popup_section .frenzy_recommendation_contain');
      const oldSwiper = container.swiper;
      if (oldSwiper) {
        oldSwiper.destroy(true, true);
      }
      document.querySelectorAll('.frenzy-swatch_item, .frenzy_auickAdd_cart, .frenzy_pro_select_option').forEach(el => el.classList.add('no-swipe'));
      const mySwiper = new Swiper(container, {
        slidesPerView: "auto",
        noSwiping: true,
        noSwipingClass: 'no-swipe',
        navigation: {
          nextEl: '.frenzy_cart_popup_section .swiper-button-next',
          prevEl: '.frenzy_cart_popup_section .swiper-button-prev',
        },
      });
    }
  },500);
}
window.addEventListener("pageshow", () => {
    const nav = performance.getEntriesByType("navigation")[0];
    if (nav.type === "back_forward") {
        document.querySelector('cart-items').refreshCart();
    }
});
// window.onFoursixtyCartUpdated = function(cart){frenzyCartCallBack(cart)}
window.FrenzyBundleAfterDetailsCallBack = (matching_products,html,index) => {
  document.querySelectorAll('.frenzy_pb_details .frenzy_bundle_product_grid .frenzy_bundle_product_details_inner').forEach((this_grid) => {
    const prodTitle = this_grid.querySelector('h6').innerHTML;
    const h3 = document.createElement('h3');
    h3.innerHTML = prodTitle;
    this_grid.querySelector('h6').replaceWith(h3);
    const prodPrice = this_grid.querySelector('.frenzy_bundle_product_main_price .money')?.innerHTML;
    const prodComparePrice = this_grid.querySelector('.frenzy_bundle_product_compare_price .money')?.innerHTML;
    this_grid.querySelector('.frenzy_bundle_product_main_price')?.setAttribute('aria-label',`Sale price: ${prodPrice}`);
    this_grid.querySelector('.frenzy_bundle_product_main_price')?.setAttribute('tabindex','0');
    this_grid.querySelector('.frenzy_bundle_product_compare_price')?.setAttribute('aria-label',`Original price: ${prodComparePrice}`);
    this_grid.querySelector('.frenzy_bundle_product_compare_price')?.setAttribute('tabindex','0');
  })
}


document.addEventListener("click", function(e) {

  const submitBtn = e.target.closest(".product-form__submit");

  if (!submitBtn) return;
  if (submitBtn.closest(".quick-view-modal")) return;

  setTimeout(function() {

  const target = document.querySelector(".custom_title-wrapper-with-link");

  if (!target) return;

  // Make focusable for screen readers

  target.setAttribute("tabindex", "-1");

  target.setAttribute("role", "heading"); // optional, depends on structure

  target.focus({ preventScroll: true });

  // Force screen reader announcement

  target.setAttribute("aria-live", "assertive");

  }, 600);

});


const QUICK_VIEW_CART_BUTTON_SELECTOR = '.customQuickViewAddToCart, .frenzyQuickViewAddToCart';
const QUICK_VIEW_CART_BUTTON_IN_MODAL_SELECTOR = '.quick-view-modal .customQuickViewAddToCart, .quick-view-modal .frenzyQuickViewAddToCart';
const FRENZY_MODAL_CART_BUTTON_SELECTOR = '.frenzy-modal-content .customQuickViewAddToCart, .frenzy-modal-content .frenzyQuickViewAddToCart';

const callQuickFunction = () =>{
  const modalContent = document.querySelector('.frenzy-modal-content');
  const sizeFieldset = document.querySelector('.frenzy-option-fieldset.frenzy-option-size .frenzy-option-selector-btns');
  const colorFieldset = document.querySelectorAll('.frenzy-option-fieldset.frenzy-option-color .color-variants-custom li');
  const cartBtn = document.querySelector(FRENZY_MODAL_CART_BUTTON_SELECTOR);

  if (!modalContent || !cartBtn) return;

  const updateSelectedOptionText = (optionClass, value) => {
    const optionValue = document.querySelector(`.frenzy-option-${optionClass} .frenzy-selected-option-value`);
    if (optionValue && value) {
      optionValue.textContent = value;
    }
  };

  const setCartButtonState = (variantId, productId, isAvailable = true) => {
    if (productId) {
      cartBtn.setAttribute('data-product_id', productId);
    }

    if (!variantId || isAvailable === false || isAvailable === 'false') {
      cartBtn.innerHTML = 'SOLD OUT';
      cartBtn.classList.add('disabled');
      cartBtn.setAttribute('disabled', 'disabled');
      cartBtn.setAttribute('data-id', variantId || '');
      return;
    }

    cartBtn.innerHTML = 'ADD TO BAG';
    cartBtn.classList.remove('disabled');
    cartBtn.removeAttribute('disabled');
    cartBtn.setAttribute('data-id', variantId);
  };

  const bindSizeLabels = () => {
    if (!sizeFieldset) return;

    sizeFieldset.querySelectorAll('li label').forEach((sizeItem) => {
      if (sizeItem.dataset.quickViewBound === 'true') return;
      sizeItem.dataset.quickViewBound = 'true';

      sizeItem.addEventListener('click', function(this_click){
        const label = this_click.currentTarget;
        const radioInput = label.querySelector('input[type="radio"]');

        if (radioInput) {
          radioInput.checked = true;
          updateSelectedOptionText('size', radioInput.value);
        }

        setCartButtonState(
          label.dataset.variantId,
          label.dataset.productId,
          label.dataset.available !== 'false'
        );
      });
    });
  };

  colorFieldset.forEach((colorItem) => {
    const colorInput = colorItem.querySelector('input');
    if (!colorInput || colorInput.dataset.quickViewBound === 'true') return;
    colorInput.dataset.quickViewBound = 'true';

    colorInput.addEventListener('change',function(this_click){
      const colorLabel = this_click.target.closest('label');
      if (!colorLabel) return;

      let sizeHTML = '';
      let selected = false;
      let proSizes = [];
      try {
        proSizes = JSON.parse(colorLabel.dataset.productSizes || '[]');
      } catch (error) {
        proSizes = [];
      }

      const sizeIndex = colorLabel.dataset.sizeIndex;
      const productId = colorLabel.dataset.productId;
      const productUrl = window.location.origin + colorLabel.dataset.productUrl;
      const productData = JSON.parse(colorLabel.getAttribute('data-product-json')) || '';
      const variantId = colorLabel.dataset.variantId;
      const colorTitle = colorLabel.dataset.colorTitle;

      function safeStringify(obj) {
        return JSON.stringify(obj).replace(/"/g, '&quot;').replace(/'/g, '&apos;');
      }

      const allImages = productData?.images || [];
      const modalImg = document.querySelector('.frenzy-modal-content variant-media img');
      if(modalImg && productData?.featured_image){
        modalImg.src = productData.featured_image;
        modalImg.removeAttribute('srcset');
      }

      const modalTitle = document.querySelector('.frenzy-modal-content .frenzyQuickTitle');
      const modalLink = document.querySelector('.frenzy-modal-content .frenzyQuickLink');
      if (modalTitle) {
        modalTitle.innerHTML = productData?.title || '';
      }
      if (modalLink) {
        modalLink.setAttribute('href', productUrl);
      }
      updateSelectedOptionText('color', colorTitle);

      const activeProductItem = active_prod_card?.closest('.frenzy_product_item');
      if (allImages.length > 0 && activeProductItem) {
        const swiperContainer = activeProductItem.querySelector('.frenzy_product_item_slider figure a');
        const productTitle = activeProductItem.querySelector('.frenzy_product_title a');
        if (swiperContainer) {
          swiperContainer.setAttribute('href', productUrl);
        }
        if (productTitle) {
          productTitle.setAttribute('href', productUrl);
        }
        if(window.innerWidth < 768 && swiperContainer){
          const wrapper = swiperContainer.querySelector('.frenzy-mobile-image-grid');
          if (wrapper) {
            wrapper.innerHTML = '';
            allImages.slice(0, 2).forEach((img, i) => {
              const slide = document.createElement('div');
              const resizedImg = img.replace(/(\.(jpg|jpeg|png|webp))(.*)?$/, '_250x$1');
              slide.className = 'swiper-slide';
              const imgClass = i === 0 ? 'frenzy_img frenzy_img_first' : 'frenzy_img frenzy_img_second';
              slide.innerHTML = `<img class="${imgClass}" src="${resizedImg}" alt="" />`;
              wrapper.appendChild(slide);
            });
            wrapper.setAttribute('data-all-images', JSON.stringify(allImages));
            wrapper.setAttribute('data-loaded-count', '2');
            if (swiperContainer.swiper) {
              swiperContainer.swiper.destroy(true, true);
              swiperContainer.swiper = null;
            }
            setTimeout(() => {
              mobielSwiperCall(swiperContainer, activeProductItem, allImages);
            }, 300);
          }
        }
      }

      if (sizeFieldset) {
        (proSizes || []).forEach((size) => {
          const matchingSize = size[sizeIndex] || size.option1 || size.option2 || size.option3 || size.title;
          let sizeDisabled = '';
          let selectedSize = '';
          if(size.available === false){
            sizeDisabled = 'is_disabled not-available';
            if (!selected && productData.available === false) {
              selectedSize = 'checked';
              selected = true;
            }
          }else if (!selected) {
            selectedSize = 'checked';
            selected = true;
          }
          if(size.available === false){
            sizeHTML += `<li class="size-li clickforsku-outer ${sizeDisabled}">
            <label for="option-Size-${matchingSize}" data-available="${size.available}" data-variant-id="${size.id}" data-variantsku="${size.sku}" data-product-id="${productId}">
            <span>${matchingSize}</span>
            <input ${selectedSize} value="${matchingSize}" id="option-Size-${matchingSize}" type="radio" name="option-Size">
            </label>
            <a href="#" class="BIS_trigger desktops la" data-product-id="${productId}" data-variantid="${size.id}" data-variant-id="${size.id}" data-product-url="${productUrl}" data-product-data="${safeStringify(productData)}"></a>
            </li>`;
          }else{
            sizeHTML += `<li class="size-li clickforsku-outer">
            <label for="option-Size-${matchingSize}" data-available="${size.available}" data-variant-id="${size.id}" data-variantsku="${size.sku}" data-product-id="${productId}">
            <span>${matchingSize}</span>
            <input ${selectedSize} value="${matchingSize}" id="option-Size-${matchingSize}" type="radio" name="option-Size">
            </label>
            </li>`;
          }
        });

        sizeFieldset.innerHTML = sizeHTML;
        const selectedInput = sizeFieldset.querySelector('input[name="option-Size"]:checked');
        const selectedLabel = selectedInput?.closest('label');
        const selectedVariantId = selectedLabel?.getAttribute('data-variant-id');
        updateSelectedOptionText('size', selectedInput?.value || '');
        setCartButtonState(
          selectedVariantId,
          productId,
          selectedLabel?.dataset.available !== 'false' && productData.available !== false
        );
        bindSizeLabels();
      } else {
        setCartButtonState(variantId, productId, productData.available !== false);
      }

      if (activeProductItem) {
        const colorTitleNode = activeProductItem.querySelector('.product_card_color_title');
        if (colorTitleNode) {
          colorTitleNode.innerText = colorTitle;
        }

        const checkColor = activeProductItem.querySelectorAll('.collection-swatch .frenzy-swatch_item[data-variant-id="'+variantId+'"]');
        if(checkColor.length > 0){
          checkColor.forEach((this_clr) => {
            const this_closest = this_clr?.closest('.custom-collection-swatches').querySelectorAll('.collection-swatch');
            const this_parentEle = this_clr?.closest('.collection-swatch');
            this_closest.forEach(item => {
              item.classList.remove('clicked','current_item');
            });
            this_parentEle.click();
            this_parentEle.classList.add('clicked','current_item');
          });
        }else{
          activeProductItem.querySelectorAll('.collection-swatch').forEach((clrItm) => {
            clrItm.classList.remove('clicked','current_item');
          });
        }
      }
    });
  });

  bindSizeLabels();

  modalContent.removeEventListener('change', frenzyCallQuickAddToCart);
  modalContent.addEventListener('change', frenzyCallQuickAddToCart);
  frenzyCallQuickAddToCart();
}
const variantAddtocartChange = async (e) =>{
  const clickTarget = e.submitter instanceof Element ? e.submitter : e.target instanceof Element ? e.target : e.target?.parentElement;
  const cartButton = clickTarget?.closest(QUICK_VIEW_CART_BUTTON_SELECTOR);
  if (!cartButton) return;

  e.preventDefault();

  if (cartButton.disabled || cartButton.classList.contains('disabled') || cartButton.getAttribute('aria-busy') === 'true') return;

  const selectedSizeLabel = document.querySelector('.quick-view-modal .frenzy-option-size input[type="radio"]:checked')?.closest('label');
  const product_id = cartButton.getAttribute('data-product_id') || selectedSizeLabel?.dataset.productId || '';
  const var_id = cartButton.getAttribute('data-id') || selectedSizeLabel?.dataset.variantId || '';

  if (!var_id || selectedSizeLabel?.dataset.available === 'false') return;

  const root = window.Shopify?.routes?.root || '/';
  const sku = product_id ? `${product_id}_${var_id}` : var_id;
  const originalText = cartButton.textContent.trim() || 'ADD TO BAG';

  window.quickviewProperties = window.quickviewProperties || {};
  window.quickviewProperties._sku = sku;

  const formData = {
    items: [{
      id: Number(var_id),
      quantity: 1,
      properties: window.quickviewProperties
    }]
  };

  cartButton.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();

    if (!response.ok || data.status === 422) {
      throw new Error(data.description || 'Unable to add product to cart.');
    }

    if (typeof frenzyProductAddToCartEventApi === 'function') {
      frenzyProductAddToCartEventApi(sku);
    }

    const quickViewModal = document.querySelector('.quick-view-modal');
    if (quickViewModal) {
      quickViewModal.dispatchEvent(new CustomEvent('quick-view:close', {
        detail: { skipReturnFocus: true }
      }));
    }

    if (typeof frenzyCartCallBack === 'function') {
      frenzyCartCallBack(data);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.querySelector('cart-drawer')?.setAttribute('open', '');
    }
  } catch (error) {
    console.error('Error:', error);
    document.dispatchEvent(new CustomEvent('cart:error', {
      bubbles: true,
      detail: {
        error: error.message
      }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } finally {
    if (document.body.contains(cartButton)) {
      cartButton.removeAttribute('aria-busy');
      cartButton.textContent = originalText;
    }
  }
}


const frenzyCallQuickAddToCart  = () =>{

      if (window.__customQuickViewAddToCartBound) return;
      window.__customQuickViewAddToCartBound = true;
      document.addEventListener('submit', function(e) {
        const submitter = e.submitter instanceof Element ? e.submitter : null;
        if (!submitter?.closest(QUICK_VIEW_CART_BUTTON_IN_MODAL_SELECTOR)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        variantAddtocartChange(e);
      }, true);
      document.addEventListener('click', function(e) {
        const clickTarget = e.target instanceof Element ? e.target : e.target?.parentElement;
        if (!clickTarget?.closest(QUICK_VIEW_CART_BUTTON_IN_MODAL_SELECTOR)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        variantAddtocartChange(e);
      }, true);
}

frenzyCallQuickAddToCart();


window.updateQuickScript = (function () {
  let observer = null;
  let debounceTimer = null;
  let isRefreshing = false;
  const refreshData = () => {
    if (isRefreshing) return; // prevent re-entry
    isRefreshing = true;
   const isCheckQuick =  document.querySelector(QUICK_VIEW_CART_BUTTON_SELECTOR);
   if(isCheckQuick){
    callQuickFunction();
   }
    //kunal
    setTimeout(() => {
      isRefreshing = false;
    }, 1000);
  };
  const debouncedRefresh = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      refreshData();
    }, 300);
  };
  return function (badgeFlg = false) {
    if (badgeFlg) {
      refreshData();
    } else {
      refreshData();
      if (!observer) {
        observer = new MutationObserver(() => {
          debouncedRefresh();
        });
        observer.observe(document.body, {childList: true, subtree: true});
      }
    }
  };
})();
